<script setup>
import SignInForm from '@maison/components/form/myAccount/SignInForm.vue';
import { PhxDivider } from '@sg/src/View/Components/Atoms/Divider';

defineProps({
  links: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div class="stack stack--spacing-4">
    <div class="heading-medium">{{ $t('Form.loginTitle') }}</div>

    <sign-in-form
      :redirect-url="links.redirectUrl"
      :should-display-submit-button="true"
      :should-show-error-in-toast="false"
      data-cy="navbar-my-account-login"
    />

    <phx-divider class="stack--spacing-4" />

    <div class="heading-medium">{{ $t('Form.noAccountYetTitle') }}</div>

    <div>
      {{ $t('Form.newCustomerText') }}
    </div>

    <a :href="links.accountCreate" class="btn btn--primary btn--plain">
      <span class="btn__text">{{ $t('MyAccount.createMyAccount') }}</span>
    </a>
  </div>
</template>
